import { render, staticRenderFns } from "./canyin.vue?vue&type=template&id=634f1ccc&scoped=true&"
import script from "./canyin.vue?vue&type=script&lang=js&"
export * from "./canyin.vue?vue&type=script&lang=js&"
import style0 from "./canyin.vue?vue&type=style&index=0&id=634f1ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f1ccc",
  null
  
)

export default component.exports